module.exports = __webpack_public_path__ + "static/media/1cc.abf8f945.jpg";